export const getMobilityOptions = () => [
  { value: 0, label: 'mobility_without' },
  { value: 5000, label: 'mobility_five' },
  { value: 10000, label: 'mobility_ten' }
];

export const getLegalOptions = () => [
  { value: 0, label: 'without_legal' },
  { value: 1, label: 'base_legal' },
  { value: 2, label: 'extended_legal' }
];

export const getDeductibleOptions = (formValues = {}) => {
  const numberClaims = formValues?.number_claims || 0;
  return numberClaims < 1
    ? [1730, 1430, 1130, 830, 630, 430, 230, 0]
    : [1730, 1430, 1130, 830];
};

export const getRcProOptions = () => {
  return [0, 50000, 100000, 150000, 200000, 300000, 500000, 750000, 1000000];
};

export const getBusinessLossOptions = () => {
  return [
    { value: 0, label: 'business_loss_without' },
    { value: 12, label: 'business_loss_12_months' },
    { value: 18, label: 'business_loss_18_months' },
    { value: 24, label: 'business_loss_24_months' }
  ];
};

export const marketOptions = [0, 60000, 120000];
